import Swiper, { Navigation } from 'swiper'
import { getBreakpointValue } from '../helpers'

const narrowSliderContainerEls = document.querySelectorAll('.narrow-slider')
const desktopColWidth = window.innerWidth / 9
narrowSliderContainerEls.forEach((sliderContainer) => {
    const narrowSwiperEl = sliderContainer.querySelector('.narrow-slider__swiper-el')
    const narrowSwiperNavigationButtonNextEl = sliderContainer.querySelector(
        '.narrow-slider__navigation button.swiper-button.next'
    )
    const narrowSwiperNavigationButtonPrevEl = sliderContainer.querySelector(
        '.narrow-slider__navigation button.swiper-button.prev'
    )

    let numOfSlides = narrowSwiperEl.querySelectorAll('.swiper-slide').length

    new Swiper(narrowSwiperEl, {
        modules: [Navigation],
        slidesPerView: 1.5,
        centeredSlides: true,
        centeredSlidesBounds: true,
        centerInsufficientSlides: true,
        spaceBetween: 46,
        navigation: { nextEl: narrowSwiperNavigationButtonNextEl, prevEl: narrowSwiperNavigationButtonPrevEl },
        breakpoints: {
            [getBreakpointValue('lg')]: {
                initialSlide: 2,
                slidesOffsetBefore: numOfSlides > 3 ? desktopColWidth * 2.5 : 0,
                slidesOffsetAfter: numOfSlides > 3 ? desktopColWidth * 1.5 : 0,
                slidesPerView: 'auto',
                spaceBetween: 0
            }
        }
    })
})
